import {createContext} from "react";
import {MultiBookingDialogContextTypes} from "../types/MultiBookingDialogContextType";

const MultiBookingDialogContext = createContext<MultiBookingDialogContextTypes>({
    currentMonth: "",
    setCurrentMonth: () => {}
})

export default MultiBookingDialogContext;